import { render, staticRenderFns } from "./reclamacoes.vue?vue&type=template&id=72bc16fc&scoped=true"
import script from "./reclamacoes.vue?vue&type=script&lang=js"
export * from "./reclamacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bc16fc",
  null
  
)

export default component.exports